import { PlatformEnum } from 'constants-activate';
import { IntegrationDefinition } from '../IntegrationDefinition';
import {
  IntegrationCategoryEnum,
  IntegrationProviderEnum,
  IntegrationTypeEnum,
} from 'constants-integrations';

const CohesiveDefinition: IntegrationDefinition = {
  name: IntegrationProviderEnum.Cohesive,
  hasCustomUI: false,
  friendlyName: 'Cohesive',
  description:
    'Integrated Service Provider (ISP) for facility management. Sends service request lifecycle notifications (created, in progress, completed) via the Public Notifications API.',
  category: IntegrationCategoryEnum.Maintenance,
  platforms: [PlatformEnum.Web, PlatformEnum.Mobile],
  type: IntegrationTypeEnum.Api,
  settings: {
    auth0ClientId: {
      friendlyName: 'Auth0 Client ID',
      description: 'M2M client ID used to authorize Cohesive API requests.',
      type: 'String',
      editable: true,
      validators: [{ name: 'Required', value: true }],
    },
  },
  properties: {},
};

export const definition = CohesiveDefinition;
